import axios from '../../../build/http-requests/axios-common'
import generateDateTime from '../../utils/generateDateTime'
import Vue from 'vue'

export default {
  state: {
  },

  mutations: {
  },

  actions: {
    getAccountEntryByIdTask: ({ commit }, obj) => {
      return new Promise((resolve, reject) => {
        axios.get(obj.url, { params: { idTarefa: obj.idTask } })
        .then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    getHistoricBankStat: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        axios.get(data.url, { params: { idBankStat: data.idBankStat } }).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    getAllotmentByBankMovementId: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        axios.get(data.url, { params: { idMovimento: data.idBankStat } })
        .then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    searchBankStatementToFile: ({ commit }, filter) => {
      return new Promise((resolve, reject) => {
        axios.post('/bankStatement/searchBankStatementToFile', filter, {responseType: 'blob'}).then(response => {
          let datetime = generateDateTime()
          let blob = new Blob([response.data])
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.setAttribute('download', Vue.i18n.translate('downloads.labels.extratoBancario') + datetime + '.csv')
          document.body.appendChild(link)
          link.click()
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },
    declassifyBankMovementList: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        axios({
          url: '/bankStatement/deleteBankMovimentList',
          method: 'DELETE',
          data: data,
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(response => {
          resolve(response.data)
        }).catch((error) => {
          reject(error)
        })
      })
    }
  },

  getters: {
  }
}



// WEBPACK FOOTER //
// ./client/store/modules/bankStatement.js